import { render, staticRenderFns } from "./AlphaCsvReview.vue?vue&type=template&id=18b5940e&scoped=true"
import script from "./AlphaCsvReview.vue?vue&type=script&lang=ts"
export * from "./AlphaCsvReview.vue?vue&type=script&lang=ts"
import style0 from "./AlphaCsvReview.vue?vue&type=style&index=0&id=18b5940e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5940e",
  null
  
)

export default component.exports